/**
 * GraphQL `order_by` for ticket list queries.
 * Default shape: `[{ e_date: "desc" | "asc" }, { tp_id: "asc" }]`
 * Coerces legacy `tp_updated_at` to `{ e_date: "desc" }`.
 */
export function ticketTableOrderBy(
  columnTypes: string,
  sortType: string
): Array<Record<string, string>> {
  if (columnTypes === "tp_updated_at") {
    return [{ e_date: "desc" }, { tp_id: "asc" }];
  }
  if (columnTypes === "e_date") {
    return [{ e_date: sortType }, { tp_id: "asc" }];
  }
  return [{ [columnTypes]: sortType }, { tp_id: "asc" }];
}
